var _rect, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaugh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 65,
    viewBox: "0 0 87 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.4795,
    y: 0.650879,
    width: 64.3944,
    height: 64,
    rx: 20,
    fill: "#FECF0C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0503 22.7769C18.0503 18.3586 21.632 14.7769 26.0503 14.7769H33.1177C37.536 14.7769 41.1177 18.3586 41.1177 22.7769V30.3458C41.1177 31.5143 40.1201 32.434 38.9555 32.3392L30.0251 31.6125C29.5849 31.5767 29.1425 31.5774 28.7023 31.6146L20.2188 32.3318C19.0519 32.4305 18.0503 31.5099 18.0503 30.3389V22.7769Z",
    fill: "#FFFDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1509 22.7769C46.1509 18.3586 49.7326 14.7769 54.1509 14.7769H61.2183C65.6365 14.7769 69.2183 18.3586 69.2183 22.7769V30.3458C69.2183 31.5143 68.2207 32.434 67.056 32.3392L58.1257 31.6125C57.6855 31.5767 57.2431 31.5774 56.8029 31.6146L48.3194 32.3318C47.1525 32.4305 46.1509 31.5099 46.1509 30.3389V22.7769Z",
    fill: "#FFFCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8018 26.3091C49.8018 21.9555 53.331 18.4263 57.6846 18.4263V18.4263C62.0381 18.4263 65.5674 21.9555 65.5674 26.3091V27.4559C65.5674 28.0988 64.9696 28.5746 64.3432 28.4305L59.2002 27.2471C57.9641 26.9627 56.6781 26.9763 55.4483 27.2868L51.0465 28.3979C50.4148 28.5574 49.8018 28.0799 49.8018 27.4283V26.3091Z",
    fill: "#880B67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9839 36.2029H63.3687V36.2029C63.3687 47.0787 54.5521 56.0938 43.6763 56.0938V56.0938C32.8005 56.0938 23.9839 47.0787 23.9839 36.2029V36.2029Z",
    fill: "#880B67"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5129_5986",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 36,
    width: 41,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9839 36.2029H63.3687V36.2029C63.3687 47.0787 54.5521 56.0938 43.6763 56.0938V56.0938C32.8005 56.0938 23.9839 47.0787 23.9839 36.2029V36.2029Z",
    fill: "#F56983"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5129_5986)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.0675,
    cy: 76.0695,
    r: 29.921,
    fill: "#F56983"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.920898 41.551C0.920898 36.8209 4.75544 32.9863 9.4856 32.9863H18.0503V41.551C18.0503 46.2812 14.2157 50.1157 9.4856 50.1157V50.1157C4.75544 50.1157 0.920898 46.2812 0.920898 41.551V41.551Z",
    fill: "#01C2F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4321 41.551C86.4321 36.8209 82.5976 32.9863 77.8674 32.9863H69.3027V41.551C69.3027 46.2812 73.1373 50.1157 77.8674 50.1157V50.1157C82.5976 50.1157 86.4321 46.2812 86.4321 41.551V41.551Z",
    fill: "#01C2F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7729 26.3091C21.7729 21.9555 25.3022 18.4263 29.6558 18.4263V18.4263C34.0093 18.4263 37.5386 21.9555 37.5386 26.3091V27.4559C37.5386 28.0988 36.9408 28.5746 36.3143 28.4305L31.1714 27.2471C29.9353 26.9627 28.6493 26.9763 27.4195 27.2868L23.0177 28.3979C22.386 28.5574 21.7729 28.0799 21.7729 27.4283V26.3091Z",
    fill: "#8A0B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaugh);
export default __webpack_public_path__ + "static/media/laugh.3303368aa86712bf467fca0f65fd3947.svg";
export { ForwardRef as ReactComponent };